/**
 * 根据路径和项目ID确定是否激活
 * @param {Array} pathArr - 路径数组
 * @param {Array} itemIds - 需要检查的项目ID
 * @returns {boolean} 是否激活
 */
export const isActivePath = (pathArr, itemIds) => {
  if (!pathArr || !itemIds || itemIds.length === 0) return false;
  return itemIds.includes(pathArr[1]);
};

/**
 * 根据路径获取产品URL和名称
 * @param {Array} pathArr - 路径数组
 * @returns {Object} 包含产品URL和产品名称ID
 */
export const getProductInfo = (pathArr) => {
  const path = pathArr[1];
  
  // 默认为温湿度监测器
  let url = 'temp-rh-monitor';
  let nameId = 'goose_lite';
  
  // 产品URL映射
  const productMap = {
    'air-monitor-2': { url: 'air-monitor-2', nameId: 'sw2' },
    'air-monitor-lite': { url: 'air-monitor-lite', nameId: 'dany_name' },
    'co2-temp-rh-monitor': { url: 'co2-temp-rh-monitor', nameId: 'ph_co2_name_value' },
    'door-window-sensor': { url: 'door-window-sensor', nameId: 'hodor_name' },
    'motion-light-sensor': { url: 'motion-light-sensor', nameId: 'parrot_name' },
    'bluetooth-gateway': { url: 'bluetooth-gateway', nameId: 'sparrow' },
    'bluetooth-alarm-clock': { url: 'bluetooth-alarm-clock', nameId: 'dove' },
    'bluetooth-clock': { url: 'bluetooth-clock', nameId: 'chicken' },
    'temp-rh-monitor-lite': { url: 'temp-rh-monitor-lite', nameId: 'duck2' },
    'temp-rh-monitor-lite-3': { url: 'temp-rh-monitor-lite-3', nameId: 'duck3' },
    'temp-rh-monitor-pro-s': { url: 'temp-rh-monitor-pro-s', nameId: 'pheasant' },
    'temp-rh-monitor-pro-e': { url: 'temp-rh-monitor-pro-e', nameId: 'frog' },
    'temp-rh-monitor-3': { url: 'temp-rh-monitor-3', nameId: 'goose3_lite' },
    'lee-guitars-thermo-hygrometer': { url: 'lee-guitars-thermo-hygrometer', nameId: 'magpie' },
    'wall-socket-thermometer': { url: 'wall-socket-thermometer', nameId: 'gecko_name' }
  };
  
  if (productMap[path]) {
    return productMap[path];
  }

  return { url, nameId };
};

/**
 * 获取应用下载链接
 * @param {boolean} isAir - 是否是空气应用
 * @returns {Object} 包含各平台下载链接
 */
export const getAppDownloadLinks = (isAir) => {
  if (isAir) {
    return {
      ios: 'https://itunes.apple.com/cn/app/%E9%9D%92%E8%90%8D%E7%A9%BA%E6%B0%94/id1344636968?mt=8',
      android: 'https://qing.cleargrass.com/download/plus',
      googlePlay: 'https://play.google.com/store/apps/details?id=com.cleargrass.app.air'
    };
  }
  
  return {
    ios: 'https://apps.apple.com/cn/app/id1481163925',
    android: 'https://qing.cleargrass.com/download/magpie',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.cleargrass.app.magpie'
  };
};

/**
 * 构建导航菜单项数据
 * @param {string} activeItem - 当前激活的项目
 * @param {Array} pathArr - 路径数组
 * @param {string} styles - 样式对象
 * @returns {Object} 包含各级导航项数据
 */
export const buildNavItems = (activeItem, pathArr, styles) => {
  // 初始化导航状态
  const firstLevelItems = Array(10).fill(null);
  const secondLevelItems = Array(16).fill(null);
  const thirdLevelItems = Array(3).fill(null);
  
  // 处理第一级导航
  if (pathArr[1] === 'temp-rh-monitor' || 
      pathArr[1] === 'temp-rh-monitor-pro-s' ||
      pathArr[1] === 'temp-rh-monitor-pro-e' ||
      pathArr[1] === 'temp-rh-monitor-lite' ||
      pathArr[1] === 'temp-rh-monitor-lite-3' ||
      pathArr[1] === 'lee-guitars-thermo-hygrometer' ||
      pathArr[1] === 'wall-socket-thermometer') {
    firstLevelItems[1] = styles.active;
  } else if (pathArr[1] === 'plus' || pathArr[1] === 'air') {
    firstLevelItems[3] = styles.active;
  } else if (pathArr[1] === 'air-monitor-2' ||
             pathArr[1] === 'air-monitor-lite' ||
             pathArr[1] === 'co2-temp-rh-monitor') {
    firstLevelItems[2] = styles.active;
  } else if (pathArr[1] === 'door-window-sensor' ||
             pathArr[1] === 'motion-light-sensor') {
    firstLevelItems[8] = styles.active;
  } else if (pathArr[1] === 'qingpingiot') {
    firstLevelItems[4] = styles.active;
  } else if (pathArr[1] === 'store') {
    firstLevelItems[5] = styles.active;
  } else if (pathArr[1] === 'bluetooth-gateway') {
    firstLevelItems[6] = styles.active;
  } else if (pathArr[1] === 'bluetooth-alarm-clock' ||
             pathArr[1] === 'bluetooth-clock') {
    firstLevelItems[7] = styles.active;
  } else if (pathArr[1] === '') {
    firstLevelItems[0] = styles.active;
  }
  
  // 处理第二级导航
  if (pathArr[1] === 'air-monitor-2') {
    secondLevelItems[13] = styles.active;
  } else if (pathArr[1] === 'air-monitor-lite') {
    secondLevelItems[5] = styles.active;
  } else if (pathArr[1] === 'co2-temp-rh-monitor') {
    secondLevelItems[11] = styles.active;
  } else if (pathArr[1] === 'door-window-sensor') {
    secondLevelItems[6] = styles.active;
  } else if (pathArr[1] === 'motion-light-sensor') {
    secondLevelItems[7] = styles.active;
  } else if (pathArr[1] === 'bluetooth-alarm-clock') {
    secondLevelItems[8] = styles.active;
  } else if (pathArr[1] === 'bluetooth-clock') {
    secondLevelItems[9] = styles.active;
  } else if (pathArr[1] === 'temp-rh-monitor-lite') {
    secondLevelItems[3] = styles.active;
  } else if(pathArr[1] === 'temp-rh-monitor-lite-3'){
    secondLevelItems[15] = styles.active;
  }else if (pathArr[1] === 'temp-rh-monitor-pro-s') {
    secondLevelItems[1] = styles.active;
  } else if (pathArr[1] === 'temp-rh-monitor-pro-e') {
    secondLevelItems[10] = styles.active;
  } else if (pathArr[1] === 'lee-guitars-thermo-hygrometer') {
    secondLevelItems[2] = styles.active;
  } else if (pathArr[1] === 'temp-rh-monitor') {
    secondLevelItems[0] = styles.active;
  } else if (pathArr[1] === 'temp-rh-monitor-3') {
    secondLevelItems[16] = styles.active;
  } else if (pathArr[1] === 'wall-socket-thermometer') {
    secondLevelItems[12] = styles.active;
  }
  
  // 处理第三级导航
  if (pathArr[2] === 'specifications') {
    thirdLevelItems[1] = styles.active;
  } else {
    thirdLevelItems[0] = styles.active;
  }
  
  return {
    firstLevelItems,
    secondLevelItems,
    thirdLevelItems
  };
}; 